const propertyAlpine = () => {
  Alpine.store('propertyData', {
    isOpen: false,
    address: '',
    concept: '',
    state: '',
    city: '',
    pdf: '',
    properties: [],
    displayedProperties: [],
    propertiesPerPage: 7,
    init() {
      this.setProperties();
    },
    setProperties() {
      let propertiesList = document.getElementById('properties');

      let propertiesData = JSON.parse(propertiesList.getAttribute('data-properties'));

      // Ensure propertiesData is an array
      if (!Array.isArray(propertiesData)) {
        propertiesData = Object.values(propertiesData);
      }

      this.properties = propertiesData;

      propertiesList.setAttribute('data-properties', '');

      this.displayedProperties = this.properties.slice(0, this.propertiesPerPage);

    },
    toggleModal() {
      this.isOpen = !this.isOpen;
    },

    loadMore() {
      let nextIndex = this.displayedProperties.length;
      let moreProperties = this.properties.slice(nextIndex, nextIndex + this.propertiesPerPage);
      this.displayedProperties = this.displayedProperties.concat(moreProperties);
    },
    setModalData(property) {
      this.isOpen = true;
      this.address = property.address;
      this.concept = property.concept;
      this.pdf = property.pdf;
      this.city = property.city;
      this.state = property.state;
      this.zip = property.zip;
    },
    updateGravityFormFields() {
      const addressInputById = document.getElementById('input_3_4');
      const conceptInputById = document.getElementById('input_3_5');

      if (addressInputById) {
        addressInputById.value = this.address;
      }

      if (conceptInputById) {
        conceptInputById.value = this.concept;
      }
    },
    reloadGravityForm() {
      var gwrf = window['gwrf_3'];
      if (typeof gwrf !== 'undefined') {
        gwrf.reloadForm();
      }
    }
  });
}
